import React from "react";
import { MusicHallRegisEventStyled } from "./styled";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useTranslation } from "react-i18next";
import { Buttons, Inputs } from "components";

const MusicHallRegisEvent = ({
  initialValues,
  isDisabledForm,
  onBack,
  onSubmit,
}) => {
  const schema = yup.object().shape({
    event_name: yup.string().required("required"),
    event_type: yup.string().required("required"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: initialValues,
  });

  const { t } = useTranslation(["common", "form", "room"]);

  return (
    <MusicHallRegisEventStyled>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="event_name_layout">
          <Controller
            control={control}
            render={({ field }) => (
              <Inputs.TextField
                {...field}
                disabled={isDisabledForm}
                label={t("Event Name", { ns: "form" })}
                // placeholder={t('test')}
                errors={errors.event_name?.message}
              />
            )}
            name="event_name"
            defaultValue=""
          />
        </div>
        <div className="type_of_event_layout">
          <div className="type_of_event_text1">
            {t("Type of Event", { ns: "form" })}
          </div>
          <div className="type_of_event_text2">
            ({t("Select as you like", { ns: "form" })})
          </div>
          <div className="checkbox_layout">
            <Controller
              control={control}
              render={({ field }) => (
                <Inputs.Radio
                  {...field}
                  disabled={isDisabledForm}
                  // placeholder={t('test')}
                  options={[
                    { label: "Concert", value: "1" },
                    { label: "Competition", value: "2" },
                    { label: "Recording", value: "3" },
                    { label: "Racital", value: "4" },
                    { label: "Rehearsal", value: "5" },
                    { label: "Master Class / Workshop", value: "6" },
                    { label: "Exhibitiont", value: "7" },
                    { label: "Seminar / Forum", value: "8" },
                  ]}
                  errors={errors.event_type?.message}
                />
              )}
              name="event_type"
              defaultValue=""
            />
          </div>
        </div>

        <div className="button_layout">
          <div className="button1">
            <Buttons.BgStandard
              theme_white_purple
              label={t("Back", { ns: "common" })}
              onClick={onBack}
            />
          </div>
          <div className="button2">
            <Buttons.BgStandard
              theme_white_purple={isDisabledForm}
              label={t("Next", { ns: "common" })}
              type="submit"
            />
          </div>
        </div>
      </form>
    </MusicHallRegisEventStyled>
  );
};

MusicHallRegisEvent.propTypes = {};

export default MusicHallRegisEvent;
